module.exports = __webpack_public_path__ + "ce2e8a7cef371f9bc7416047e60ab606.MP3";